/**
 * Строит query-строку единого поиска для бэкенда: один фильтр типа `search`,
 * который на бэке ищет ILIKE по всем перечисленным полям (в отдельной where-группе).
 *
 * @param {string} value  значение из инпута
 * @param {string[]} fields  поля БД, напр. ["id", "name->>'ru'", "external_guid"]
 * @returns {string}  напр. "&filters[0][t]=search&filters[0][f]=...&filters[0][v]=..." или ""
 */
export function buildSearchFilter(value, fields) {
  const trimmed = (value ?? "").trim()
  if (!trimmed || !fields || fields.length === 0) {
    return ""
  }

  const f = encodeURIComponent(fields.join(","))
  const v = encodeURIComponent(trimmed)

  return `&filters[0][t]=search&filters[0][f]=${f}&filters[0][v]=${v}`
}
